/**
 * How practice turns into codename letters: every correct word reveals letters (more than one when
 * the codename is long for the floor's words, see lettersPerWord), and progress (a clearly closer
 * attempt, a correct practice syllable, moving on after improving) earns partial credit, so a
 * child who is improving keeps moving forward without errors being called correct.

/** Progress credits that add up to one letter. */
export const PROGRESS_PER_LETTER = 2;

/**
 * Letters per correct word, so a mission's words uncover the codename up to its last letter as
 * they go (Cipher Cat: 9 letters, 5 syllables, 2 a word) instead of most of it appearing at once
 * when the stars uncover the rest (QA 2026-10-11).
 */
export function lettersPerWord(totalLetters: number, words: number): number {
  return Math.max(1, Math.ceil((totalLetters - 1) / Math.max(1, words)));
}

export function lettersRevealed(
  alreadyRevealed: number,
  successes: number,
  progressCredits: number,
  totalLetters: number,
  perWord = 1,
): number {
  const earned = (successes + Math.floor(progressCredits / PROGRESS_PER_LETTER)) * perWord;
  return Math.min(totalLetters, alreadyRevealed + earned);
}
